module.exports = __webpack_public_path__ + "assets/favicons/favicon-16x16.5eb376bf1a1dc3810eb7e0c4041a24cb.png";